import theme from "utils/themeVars"
import { Button, Icon, Text } from ".."
import { Flex } from "antd"

export const AIBadgeScore = ({
  padding = "pi-12",
  title,
  totalScore,
  icon,
  handleDrawer,
  buttonProps,
  iconProps,
  titleClassName,
}) => {
  const getCallScoreColor = score => {
    if (!score) return theme["error-color"]
    let parts = score?.split("/")
    return Number(parts[0]) < 50 ? theme["error-color"] : theme["accent-color"]
  }

  return (
    <Button
      text={
        <Flex gap={4}>
          {(title || totalScore) && (
            <Text strong className={titleClassName} color={getCallScoreColor(totalScore)}>
              {title && title} {totalScore && totalScore}
            </Text>
          )}
          {icon && <Icon size={14} icon={icon} className={getCallScoreColor(totalScore)} />}
        </Flex>
      }
      icon={"SvgIconAi"}
      size="large"
      type="light"
      color={getCallScoreColor(totalScore)}
      className={padding}
      style={{ height: 46 }}
      onClick={e => {
        e.stopPropagation()
        handleDrawer?.()
      }}
      iconProps={iconProps}
      {...buttonProps}
    />
  )
}
